import React from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import DateTimePicker from 'react-datetime-picker';
import RenderingImage from '../../common/RenderingImage';
import RichTextEditor from '../../common/RichTextEditor';
import ImageSelect from './ImageSelect';
import 'react-datetime-picker/dist/DateTimePicker.css';
import './Form.less';

export default function NewsEditForm(props) {
  const {
    imageFileId,
    markToDelete,
    //
    postId,
    postHeader,
    postContent,
    postImage,
    postUploadDate,
    //
    setMarkToDelete,
    setPostHeader,
    setPostContent,
    setPostUploadDate,
    setPostImage,
  } = props;

  return (
    <Form>

      <Row className="mb-4">
        <Form.Group>
          <Form.Label className="d-flex justify-content-between">
            Заголовок

            {postHeader && (
              <span style={{ color: postHeader.length >= 500 ? 'red' : undefined }}>
                {postHeader.length}
                /500
              </span>
            )}
          </Form.Label>
          <Form.Control as="textarea" maxLength="500" value={postHeader} onChange={(e) => setPostHeader(e.target.value)} />
        </Form.Group>
      </Row>

      <Row className="mb-4">
        <Form.Group>
          <Form.Label>Содержание</Form.Label>
          <RichTextEditor onChange={setPostContent} value={postContent} />
        </Form.Group>
      </Row>

      <Row className="mb-4">
        <Form.Group as={Col} md="8">
          <Form.Label>Прикрепленное изображение</Form.Label>

          {imageFileId && 
            <div style={styledImageContainer}>
              <RenderingImage url={`/minioFiles/download/${imageFileId}`} style={styledImage} />
              <Button onClick={() => setMarkToDelete(true)} variant="light" className="btn-close" size="sm" />
            </div>
          }

          <div>
            <ImageSelect
              postId={postId}
              file={postImage}
              setFile={setPostImage}
              imageFileId={imageFileId}
              markToDelete={markToDelete}
              setMarkToDelete={setMarkToDelete}
            />
          </div>
        </Form.Group>
        <Form.Group as={Col} md="4" className='d-flex flex-column'>
          <Form.Label>Дата публикации</Form.Label>
          <DateTimePicker
            onChange={setPostUploadDate}
            value={postUploadDate}
            clearIcon={null}
            disableClock={true}
            format='dd.MM.y HH:mm'
          />
        </Form.Group>
      </Row>
    </Form>
  );
}

const styledImageContainer = {
  display: 'flex',
  alignItems: 'center',
  maxWidth: '300px',
  marginBottom: '10px',
}

const styledImage = {
  width: '90%',
  height: 'auto',
  marginRight: '4px',
}
